import { Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ButtonProps } from '@material-ui/core/Button/Button';

export type LoadingButtonProps = ButtonProps & {
  loading?: boolean,
  loadingSize?: number,
};

const LoadingButton = ({
  loading = false,
  loadingSize = 20,
  disabled,
  startIcon,
  children,
  ...rest
}: LoadingButtonProps) => (
  <Button
    disabled={disabled || loading}
    startIcon={loading ? <CircularProgress size={loadingSize} color="inherit" /> : startIcon}
    {...rest as ButtonProps}>
    {children}
  </Button>
);

export default LoadingButton;
